module.exports = " <div class=filter-categories v-if=filters.offering.length> <accordion title=Offering :items=filters.offering @changed=updateOfferingFilter></accordion> <accordion title=Categories :items=filters.categories @changed=updateCategoriesFilter></accordion> <accordion title=Items :items=filters.items @changed=updateItemsFilter></accordion> <accordion title=\"Min Resolution\" :items=filters.resolutions @changed=updateResolution></accordion> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/views/filter/FilterCategories.vue
// module id = 187
// module chunks = 0